module.exports = __webpack_public_path__ + "static/media/nodata.5edd86b9.jpg";